export default {
  'Gérer les congés': 'Manage',
  'Historique des congés': 'History',
  Groupes: 'Groups',
  Demandes: 'Requests',
  'Mes congés': 'My leave requests',
  Congés: 'Leave requests',
  'Congés de mon équipe': "My teams's leave requests",
  Ajustements: 'Adjustments',
  'Gestion des congés': 'Time Off Management',
  COUNTRY_ENTITLEMENTS: {
    TITLE: 'Rights by country',
    DESCRIPTION: 'Enable indicative estimates and adjust the number of days for the countries where your sites operate.',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    NO_COUNTRIES: 'No country is associated with your company sites.',
    NO_DEFAULTS: 'No default entitlement is configured for this country.',
    LEAVE_TYPE: 'Leave type',
    PERIOD: 'Period',
    DEFAULT: 'Default estimate',
    COMPANY_MAXIMUM: 'Company value',
    SAVE: 'Save values',
    LOAD_ERROR: 'Unable to load country leave rights',
    REQUEST_LOAD_ERROR: 'Unable to load available leave types',
    SELECT_EMPLOYEE_FIRST: 'Select an employee first',
    LOADING_TYPES: 'Loading leave types...',
    NO_AVAILABLE_TYPES: 'No leave type is available for this country',
    ACTIVE_COUNTRIES: 'active countries out of {{total}}',
    SELECT_COUNTRY: 'Choose a country',
    CONFIGURED_TYPES: 'configured types',
    ACTIVATION_HELP: 'Show these estimates to employees',
    DISABLED_TITLE: 'Estimates are disabled for this country',
    DISABLED_HELP: 'The leave request form keeps its current behavior until this option is enabled.',
    SEARCH_PLACEHOLDER: 'Search for a leave type',
    RESULTS: 'results',
    NO_RESULTS: 'No leave type matches this search.',
    INDICATIVE_HELP: 'These values are indicative, editable by your company, and never block a request.',
    ACTIVATION_SUCCESS: 'Country configuration updated',
    ACTIVATION_ERROR: 'Unable to update the country',
    SAVE_SUCCESS: 'Maximums saved successfully',
    SAVE_ERROR: 'Unable to save maximums',
    REQUEST_MAXIMUM: 'Indicative company estimate: {{days}} days',
    PERIODS: {
      YEAR: 'per year',
      EVENT: 'per event',
      CONTRACT: 'over the contract term',
      LIFETIME: 'over the full career',
    },
  },
  GROUPS: {
    'Nom du groupe': 'Group Name',
    Description: 'Description',
    Site: 'Site',
    Actions: 'Actions',
    'Nouveau groupe de congé': 'New Leave Group',
    'Rechercher un groupe': 'Search Group',
    'Ajouter des types de congé': 'Add Leave Types',
    'Modifier le groupe de congés': 'Edit Leave Group',
    'Type de congé': 'Leave Type:',
    Solde: 'Balance:',
    'jours par': 'days per',
    mois: 'month',
    année: 'year',
    'Date du cycle': 'Cycle Resets on:',
    'Ajouter un type de congé': 'Add Leave Type',
    'Supprimer le groupe de congés': 'Delete Leave Group',
    'Êtes-vous sûr de vouloir supprimer ce groupe de congés?': 'Are you sure you want to delete this leave group?',
    'Groupe de congés supprimé avec succès': 'Leave group deleted successfully',
    'Erreur lors de la suppression du groupe de congés': 'Error deleting leave group',
    LEAVE_GROUPS_TABLE_EMPTY: 'Create your first leave group by clicking the button above. 😊',
    VALIDATION: {
      GROUP_NAME: 'Please enter a group name',
      SITE_NAME: 'Please select a site',
      LEAVE_TYPE_MISSING: 'Please add at least one leave type',
      LEAVE_TYPE_INVALID: 'Please verify the fields for the leave types',
    },
    TOASTR: {
      GROUP_CREATED: 'Leave group created successfully',
      ERROR_CREATING_GROUP: 'Error creating leave group',
      GROUP_UPDATED: 'Leave group updated successfully',
      ERROR_UPDATING_GROUP: 'Error updating leave group',
    },
    'cumulés mensuellement': 'accumulated monthly',
    'acquis en début de cycle': 'acquired at the beginning of the cycle',
    'en fin du mois': 'at the end of the month',
    'en fin de cycle': 'at the end of the cycle',
    'Acquisition:': 'Acquisition:',
    'de chaque année': '1st, every year',
    'Le 1er': '',
    'Type de jours': 'Day type',
    'Jours ouvrés': 'Working days',
    'Jours ouvrables': 'Business days',
    'Paramétrer :': 'Settings with :',
  },
  'Aucune demande de congé trouvée ': 'There are no leave requests yet. Click the button above to create one easily.',
  'Aucune demande de congé trouvée (admin)': 'No leave requests? Click the button above to declare one easily.',
  'Aucune demande de congé trouvée (user)': 'This employee has no leave requests at the moment.',
  'Aucune demande de congé trouvée (team)': 'No leave requests for this team at the moment.',
  'Déclarer un congé': 'Declare a leave',
  'Demander un congé': 'Request a leave',
  'Demande effectuée': 'Request made',
  CANCEL_LEAVE_REQUEST_TITLE: 'Cancel leave request',
  CANCEL_LEAVE_REQUEST_CONFIRMATION: 'Are you sure you want to cancel this leave request?',
  LEAVE_REQUEST_CANCELLED_SUCCESS: 'Leave request cancelled successfully',
  LEAVE_REQUEST_CANCEL_ERROR: 'Error cancelling leave request',
  ERROR_FETCHING_LEAVE_REQUESTS: 'Error fetching leave requests',
  "jours à l'avance": 'days in advance',
  'jours en retard': 'days late',
  'àprès la date de début': 'after the start date',
  'le jour même': 'on the same day',
  'Demande effectuée le:': 'Request made on:',
  'Demande approuvée le:': 'Request approved on:',
  'Demande refusée le:': 'Request declined on:',
  par: 'by',
  'Voir la pièce jointe': 'View Attachment',
  'Détails de la demande de congé': 'Leave Request Details',
  'Approbation de la demande de congé': 'Leave Request Approval',
  'Voir les détails du congé': 'View leave details',
  'Ouvrir l’écran de gestion du congé': 'Open the leave management screen',
  days: 'days',
  'Justificatifs:': 'Supporting comment or document:',
  'Ajouter un commentaire': 'Add a comment',
  "Commentaire d'approbation:": 'Approval comment',
  Commentaire: 'Comment',
  'En cours...': 'Loading...',
  Approuver: 'Approve',
  Refuser: 'Decline',
  Collaborateur: 'Employee Name',
  'Type de congé': 'Leave Type',
  'Date de début': 'Start Date',
  'Date de fin': 'End Date',
  'Date de demande': 'Request Date',
  'Total demandé': 'Total Requested',
  Statut: 'Status',
  Tous: 'All',
  'En attente': 'Pending',
  Approuvée: 'Approved',
  Refusée: 'Declined',
  Annulée: 'Cancelled',
  Actions: 'Actions',
  'Appliqué pour': 'Applies to',
  Date: 'Date',
  "Date d'ajustement": 'Adjustment Date',
  Valeur: 'Value',
  Comptabilisé: 'Accounted',
  'Créer un ajustement': 'Create Adjustment',
  "Modifier l'ajustement de ": 'Edit Adjustment for ',
  "Voir l'ajustement de ": 'Adjustment for ',
  "Pas d'ajustements": 'No adjustments yet? Click the button above to create one. 😊',
  "Date d'ajout": 'Date Added',
  'Voir le solde de congés': 'View Leave Balance',
  'Compteurs de solde de congés': 'Leave Balance Counters',
  BALANCE_SUBTITLE: 'Summary of your leave counters',
  ADJUSTMENTS: {
    DELETE_CONFIRMATION_TITLE: 'Delete Adjustment',
    DELETE_CONFIRMATION_MESSAGE: 'Are you sure you want to delete this adjustment?',
    ADJUSTMENT_DELETED_SUCCESSFULLY: 'Adjustment deleted successfully',
  },
  Acquis: 'Earned',
  'Pris': 'Used',
  'Solde Restant': 'Total remaining',
  'En attente de validation': 'Pending',
  'Acquis / N-1': 'Earned / N-1',
  'En aquisition': 'Currently acquiring',
  'En aquisition / N': 'Currently acquiring / N',
  'Jours fériés non payés': 'Non-working public holidays',
  'Ajouter un jour férié': 'Add a public holiday',
  'Date du jour férié': 'Public holiday date',
  'Site concerné': 'Concerned site',
  'Aucun jour férié trouvé': 'No unpaid public holidays defined. Click on the button above to add one.',
  'Jour férié ajouté avec succès': 'Unpaid public holiday added successfully',
  "Erreur lors de l'ajout du jour férié": 'Error adding unpaid public holiday',
  'Confirmer la suppression': 'Confirm deletion',
  'Voulez-vous vraiment supprimer ce jour férié ?': 'Do you really want to delete this unpaid public holiday?',
  'Jour férié supprimé avec succès': 'Unpaid public holiday successfully deleted',
  'Erreur lors de la suppression du jour férié': 'Error deleting unpaid public holiday',
  CUSTOM_HOLIDAYS: {
    TITLE: 'Unpaid public holidays',
    ADD_UNPAID_HOLIDAY: 'Add unpaid public holiday',
    ADD_MODAL_TITLE: 'Add unpaid public holidays',
    SITE: 'Concerned site',
    SELECT_SITE: 'Select a site',
    SELECT_HOLIDAYS: 'Select holidays to add',
    NO_HOLIDAYS_FOUND: 'No standard holidays found for this site',
    SELECT_AT_LEAST_ONE: 'Please select at least one holiday',
    ERROR_LOADING_HOLIDAYS: 'Error loading standard holidays',
    DATE_COLUMN: 'Holiday Date',
    SITE_COLUMN: 'Affected Site',
    NO_HOLIDAYS: 'No holidays found',
    DUPLICATE_HOLIDAY: 'This holiday already exists for this site',
    SUCCESS_ADD: 'Unpaid public holidays added successfully',
    SUCCESS_ADD_SINGLE: 'Unpaid public holiday added successfully',
    SUCCESS_ADD_MULTIPLE: '{{count}} unpaid public holidays added successfully',
    SKIPPED_SINGLE: 'Holiday was skipped because it already exists',
    SKIPPED_MULTIPLE: '{{count}} holidays were skipped because they already exist',
    ALL_DUPLICATES: 'All selected holidays already exist',
    ERROR_ADD: 'Error adding unpaid public holidays',
  },
  RELIGIOUS_HOLIDAYS: {
    TITLE: 'Religious dates',
    HOLIDAY: 'Holiday',
    COUNTRY: 'Country',
    YEAR: 'Year',
    PREDICTED_DATE: 'Predicted date',
    OFFICIAL_DATE: 'Official date',
    DURATION: 'Duration (days)',
    STATUS: 'Status',
    ALL_STATUSES: 'All statuses',
    PREDICTED: 'Predicted',
    OFFICIAL: 'Official',
    CANCELLED: 'Cancelled',
    CONFIRM: 'Confirm',
    CORRECT: 'Correct',
    CONFIRM_TITLE: 'Confirm religious date',
    CORRECT_TITLE: 'Correct religious date',
    DISPLAY_NAME: 'Display name',
    CONFIRMATION_NOTE: 'Confirmation note',
    NO_DATA: 'No religious date found for these filters',
    NO_CONFIGURED_COUNTRY: 'No religious dates are configured for your company countries',
    LOAD_ERROR: 'Error loading religious dates',
    CONFIRM_SUCCESS: 'Religious date confirmed successfully',
    CONFIRM_ERROR: 'Error confirming religious date',
    PREDICTED_HINT: 'Predicted date, subject to change',
    PREDICTED_LEGEND: 'Predicted public holiday',
    REMINDER_MESSAGE: 'The predicted date for “{{holidayName}}” is {{predictedDate}}. Remember to review and confirm it.',
    REMINDER_LOAD_ERROR: 'Error loading religious date reminders',
  },
  'Ajouter des jours fériés non payés': 'Add non-working public holidays',
  'Sélectionner un site': 'Select a site',
  'Sélectionner les jours fériés à ajouter': 'Select holidays to add',
  'Aucun jour férié standard trouvé pour ce site': 'No standard holidays found for this site',
  'Veuillez sélectionner au moins un jour férié': 'Please select at least one holiday',
  Chargement: 'Loading',
  'Rechercher un site': 'Search for a site',
  'Aucun site trouvé': 'No site found',
  'Vue mensuelle': 'Monthly view',
  'Synchronisation paie': 'Payroll synchronization',
  MONTHLY_CALENDAR: {
    TITLE: 'Monthly availability view',
    PRESENT: 'Present',
    PENDING: 'Pending leave',
    VALIDATED: 'Validated leave',
    DAY_OFF: 'Holiday / Off',
  },
  PAYROLL_SYNC: {
    CURRENT_MONTH: 'Current month',
    SEARCH_PLACEHOLDER: 'Search employee',
    API_SYNC: 'Sync via API',
    EXCEL_SYNC: 'Sync Excel',
    SAVE_ALL: 'Save all',
    MONTH_END_COUNTERS: 'Payroll counters at month end',
    SELECT_LEAVE_TYPE: 'Select a leave type to display counters.',
    EMPLOYEE: 'Employee',
    EARNED_N: 'Earned N',
    TAKEN_N: 'Taken N',
    BALANCE_N: 'Balance N',
    EARNED_N_MINUS_1: 'Earned N-1',
    TAKEN_N_MINUS_1: 'Taken N-1',
    BALANCE_N_MINUS_1: 'Balance N-1',
    NO_DATA: 'No data found for this period.',
    LEAVE_TYPES_ERROR: 'Error loading leave types',
    LOAD_ERROR: 'Error loading payroll leave history',
    SAVE_SUCCESS: 'Payroll leave history saved successfully',
    SAVE_ERROR: 'Error saving payroll leave history',
    DELETE_ROW: 'Delete counters',
    DELETE_TITLE: 'Confirm deletion',
    DELETE_CONFIRM: 'Delete the saved payroll counters for this employee and period?',
    DELETE_HINT: 'This only deletes the payroll history for this row. The employee and contracts will not be deleted.',
    DELETE_ACTION: 'Delete',
    DELETE_SUCCESS: 'Payroll counters deleted successfully',
    DELETE_ERROR: 'Error deleting payroll counters',
    IMPORT: {
      BUTTON: 'Import Excel',
      TITLE: 'Import payroll counters',
      DROP_FILE: 'Drop your Excel file here',
      FILE_HELP: '.xls or .xlsx formats, maximum 5 MB',
      CHOOSE_FILE: 'Choose file',
      DOWNLOAD_TEMPLATE: 'Download Excel template',
      ANALYZE: 'Analyze file',
      CANCEL: 'Cancel',
      APPLY: 'Apply to table',
      REVALIDATE: 'Revalidate rows',
      DELETE_ROW: 'Delete row',
      EMAIL: 'Email',
      TARGET_MONTH: 'Target month',
      TARGET_TYPE: 'Target leave type',
      IMPORT_ROWS: 'Rows to import',
      ERROR_ROWS: 'Errors to correct',
      TOTAL: 'Total',
      VALID: 'Valid',
      CONFLICTS: 'Conflicts',
      ERROR_COUNT: 'Errors',
      DELETED: 'Deleted',
      STATUS: 'Status',
      STATUS_VALID: 'Valid',
      STATUS_CONFLICT: 'Existing value changed',
      STATUS_UNCHANGED: 'Unchanged',
      MATRICULE: 'Employee number',
      EXCEL_ROW: 'Excel row {{row}}',
      BLOCKED_UNSAVED: 'Save or discard current changes before importing.',
      APPLIED_TOAST: '{{count}} rows imported into the table. Review the values, then click Save all.',
      ERRORS: {
        FILE_REQUIRED: 'Select an Excel file.',
        FILE_TOO_LARGE: 'The file exceeds the 5 MB limit.',
        INVALID_FILE: 'The file is invalid.',
        INVALID_FILE_TYPE: 'Use an .xls or .xlsx file.',
        EMPTY_WORKBOOK: 'The workbook has no worksheet.',
        EMPTY_SHEET: 'The worksheet contains no data.',
        INVALID_HEADERS: 'The file headers are invalid or incomplete.',
        UNREADABLE_WORKBOOK: 'The workbook is corrupted, protected, or unreadable.',
        IDENTIFIER_REQUIRED: 'Email or employee number is required.',
        MATRICULE_REQUIRED: 'The employee number is required.',
        UNKNOWN_EMAIL: 'The email does not match an active employee.',
        DUPLICATE_EMAIL: 'The email appears more than once in the file.',
        AMBIGUOUS_EMAIL: 'The email matches multiple employees.',
        UNKNOWN_MATRICULE: 'The employee number does not match an active employee.',
        DUPLICATE_MATRICULE: 'The employee number appears more than once in the file.',
        AMBIGUOUS_MATRICULE: 'The employee number matches multiple employees.',
        NON_NUMERIC_VALUE: 'The counter must be numeric.',
        TEMPLATE_DOWNLOAD: 'Unable to download the Excel template.',
        SERVER_ERROR: 'A server error occurred.',
      },
    },
  },
}
